<template>
    <div>
        <div class="dfjc">
            <el-input
                    prefix-icon="el-icon-search"
                    placeholder="输入关键字进行查找品种"
                    v-model="search"
            @change="searchbtn">
            </el-input>
<!--            <el-button icon="el-icon-search" circle @click="searchbtn" style="margin-left: 20px"></el-button>-->
        </div>
        <div class="hisbox">
            <span v-for="(item,index) in historyData" :key="index+'h'" @click="his(item)" class="hiscss">{{item}}</span>
        </div>
        <div class="con" :style="'height:'+tableHeight+'px'">
        <el-table ref="table"
                  row-key="name_id"
                    border
                    size="mini"
                    :data="pzdata"
                    :height="tableHeight"
                    @selection-change="choosepz"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true">
            <el-table-column type="selection"  width="40" :reserve-selection="true"> </el-table-column>
            <el-table-column label="品种大类" prop="product_name" show-overflow-tooltip>  </el-table-column>
            <el-table-column :label="$t('form_product_name')" prop="name" show-overflow-tooltip>  </el-table-column>
            <el-table-column label="规格" prop="model" show-overflow-tooltip>  </el-table-column>
            <el-table-column label="单位" prop="unit" show-overflow-tooltip>  </el-table-column>
        </el-table>
        </div>
        <el-pagination

                @size-change="handleSizeChange"
                @current-change="pageCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total,sizes,prev,pager,next"
                :total="total"
        >
        </el-pagination>
        <div class="center"style="margin-top: 15px;">
            <el-button @click="save" :class="baseerp+'btn'" size="mini">
                {{$t('button_confirm')}}
            </el-button>
        </div>


    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "PzList",
        components: {},
        props:{
            add:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                pzdata: [],
                search:'',
                pzid:[],
                baseerp:'',
                pzitem:[],
                currentPage:1,
                pageSize:10,
                total:0,
                historyData:[],
                tableHeight:0,
                choosePzList:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            add:{
                handler(){
                    // this.currentPage=1
                    // this.getPzListBySx()

                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            if (JSON.parse(localStorage.getItem('pzHistory'))){
                this.historyData=JSON.parse(localStorage.getItem('pzHistory'))
            }
            this.baseerp=baseerp;

            this.getPzListBySx()
            this.$nextTick(()=>{
                this.onResize();
                // console.log(this.add,'add')
            })
            // this.baseerp=baseerp;
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-100

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            searchbtn(){
                if (this.search!=''){
                    if(this.historyData.includes(this.search)){
                        let i=this.historyData.indexOf(this.search);
                        this.historyData.splice(i,1);
                    }
                    if (this.historyData.length>20){
                        this.historyData.splice(0,20);
                    }
                    this.historyData.unshift(this.search);
                    localStorage.setItem('pzHistory',JSON.stringify(this.historyData));
                }
                this.currentPage=1
                this.getPzListBySx()
            },
            his(name){
                this.currentPage=1
                this.search=name
                this.getPzListBySx()
            },
            async getPzListBySx(){
                // console.log(resolve,'resolve',val)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let param={
                    i_mid: this.mid,
                    vc_flags:this.add.vc_flags,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.search,
                };
                let res=await API.getPzListBySx(param);
                if ( res.code == 1 ){
                    this.pzdata=res.data.list

                    this.$nextTick(()=>{
                        for(let i=0;i<this.pzdata.length;i++){
                            let pz= this.pzdata[i];
                            for(let s of this.add.sub){
                                if(pz.name_id==s.name_id){
                                    this.$refs.table.toggleRowSelection(this.pzdata[i],true)

                                }
                            }
                        }
                    });
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getPzListBySx()
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getPzListBySx();
            },
            choosepz(val){
                this.choosePzList=val
            },
            save(){
                this.$emit('close',this.choosePzList)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .con{
        /*height: 500px;*/
        overflow-y: auto;
    }
    .center{
        text-align: center;
    }
    .hiscss{
        display: inline-block;
        padding: 3px 5px;
        background-color: #b2b2b2;
        color: white;
        font-size: 12px;
        border-radius: 6px;
        margin: 3px;
    }
    .hisbox{
        min-height: 29px;
        margin-top: 3px;
    }
</style>